export default {
  Title: 'Μηνύματα | Μήνυμα | Μηνύματα',

  Toolbar: {
    Subtitle: 'Λίστα μηνυμάτων',
    Icon    : 'email',
    Color   : 'indigo',
    Button  : {
      New: {
        Title: 'Νέο μήνυμα',
        Icon : 'add_box'
      },
      Filter: {
        Title: 'Φιλτράρισμα με',
        Icon : 'filter_list'
      },
      Group: {
        Title: 'Ομαδοποίηση με',
        Icon : 'more_vert'
      }
    },
    Label: {
      Dear   : 'Αγαπητέ/ή',
      Sender : 'Αποστολέα',
      Reading: {
        Read  : 'Αναγνωσμένα',
        Unread: 'Μη Αναγνωσμένα'
      },
      Importance: {
        Important: 'Σημαντικά',
        Regular  : 'Κανονικά'
      },
      Type: 'Τύπο'
    }
  },
  ListView: {
    Select: {
      Title   : 'Επιλέξτε Μήνυμα',
      Subtitle: 'Επιλέξτε μήνυμα από τη λίστα',
      Icon    : 'email'
    },
    NoData: {
      Subtitle: 'Δεν υπάρχουν μηνύματα ακόμη',
      Icon    : 'email'
    },
    Send: {
      Success: 'Το μήνυμα στάλθηκε επιτυχώς!'
    }
  },

  Template: {
    SaveSuccess        : 'Το πρότυπο αποθηκεύτηκε επιτυχώς!',
    DeleteSuccess      : 'Το πρότυπο διαγράφηκε επιτυχώς!',
    ConfirmDeleteDialog: {
      Title  : 'Διαγραφή Προτύπου;',
      Content: 'Είστε σίγουροι ότι θέλετε να διαγράψετε το πρότυπο "<span class="font-weight-light font-italic">{title}</span>";',
      Warning: 'Η διαγραφή είναι οριστική και η διαδικασία είναι μη αναστρέψιμη'
    }
  },

  ConfirmDeleteDialog: {
    Title  : 'Διαγραφή Μηνύματος;',
    Content: 'Είστε σίγουροι ότι θέλετε να διαγράψετε το μήνυμα "<span class="font-weight-light font-italic">{title}</span>" που στάλθηκε <strong>{dateTime}</strong>;',
    Warning: 'Η διαγραφή είναι οριστική και η διαδικασία είναι μη αναστρέψιμη',
    Success: 'Το μήνυμα έχει διαγραφεί επιτυχώς'
  },

  ConfirmSendWithEmailDialog: {
    Title          : 'Αποστολή Μηνύματος με Email;',
    ContentSpecific: 'Είστε σίγουροι ότι θέλετε να στείλετε με email το μήνυμα "<span class="font-weight-light font-italic">{title}</span>" που στάλθηκε <strong>{dateTime}</strong> στους χρήστες των domains <strong>{domains}</strong>;',
    ContentAll     : 'Είστε σίγουροι ότι θέλετε να στείλετε με email το μήνυμα "<span class="font-weight-light font-italic">{title}</span>" που στάλθηκε <strong>{dateTime}</strong> στους χρήστες <strong>όλων των domains</strong>;'
  },

  ConfirmSendWithMessageDialog: {
    Title          : 'Αποστολή Εσωτερικού Μηνύματος;',
    ContentSpecific: 'Είστε σίγουροι ότι θέλετε να στείλετε το εσωτερικό μήνυμα "<span class="font-weight-light font-italic">{title}</span>" που στάλθηκε <strong>{dateTime}</strong> στους χρήστες των domains <strong>{domains}</strong>;',
    ContentAll     : 'Είστε σίγουροι ότι θέλετε να στείλετε το εσωτερικό μήνυμα "<span class="font-weight-light font-italic">{title}</span>" που στάλθηκε <strong>{dateTime}</strong> στους χρήστες <strong>όλων των domains</strong>;'
  },

  ConfirmSendDialog: {
    Title          : 'Αποστολή Μηνύματος;',
    ContentSpecific: 'Είστε σίγουροι ότι θέλετε να στείλετε το μήνυμα στους χρήστες των domains <strong>{domains}</strong>;',
    ContentAll     : 'Είστε σίγουροι ότι θέλετε να στείλετε το μήνυμα στους χρήστες <strong>όλων των domains</strong>;'
  },

  MessageSendDialog: {
    Toolbar: {
      Title   : '@:Message.Toolbar.Button.New.Title',
      Subtitle: 'Αποστολή νέου μηνύματος',
      Icon    : 'email',
      Color   : 'indigo'
    },
    Field: {
      MessageType: {Label: 'Τύπος Μηνύματος'},
      Sender     : {Label: 'Αποστολέας'},
      Important  : {
        Label  : 'Σημαντικό',
        IconOn : 'fas fa-exclamation-circle',
        IconOff: 'far fa-circle'
      },
      DateSent: {
        Label: 'Ημερομηνία Αποστολής',
        Icon : 'event'
      },
      ExpiredAt: {
        Label: 'Ημερομηνία Λήξης',
        Icon : 'event'
      },
      HourSent: {
        Label: 'Ώρα Αποστολής',
        Icon : 'access_time'
      },
      SentTo: {
        Label      : 'Προς',
        Placeholder: 'Όλους'
      },
      MessageTitle: {
        Label      : 'Τίτλος',
        Placeholder: 'Τίτλος Μηνύματος'
      }
    }
  }
}
